import React, { useEffect } from 'react';
import { connect } from "react-redux";
import { setBreadcrumbItems } from "../../store/actions";
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb";
import { Row, Col } from "reactstrap";
import EmailConfig from './EmailConfig';
import CorsConfig from './CorsConfig';
import './SiteConfig.scss';

const SiteConfig = (props) => {
  document.title = "Site Configuration | Pixwik";

  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "Site Configuration", link: "#" },
  ];

  useEffect(() => {
    props.setBreadcrumbItems('Site Configuration', breadcrumbItems);
  }, []);

  return (
    <div className="site-config">
      <Row>
        <Col xs="12">
          <div className="site-config-header d-flex align-items-center justify-content-between">
            <CustomBreadCrumb data={breadcrumbItems} pageTitle="Site Configuration" />
          </div>
        </Col>
      </Row>

      <Row className="mt-4">
        <Col xs="12">
          <EmailConfig />
        </Col>
      </Row>

      <Row className="mt-4">
        <Col xs="12">
          <CorsConfig />
        </Col>
      </Row>
    </div>
  );
};

export default connect(null, { setBreadcrumbItems })(SiteConfig);